import { UpdateUserDto, UsersV2Api } from '../../../api-client';
import { UseMutationOptions } from 'react-query/types/react/types';
import { AxiosResponse } from 'axios';
import { ErrorResponse } from '../../../common/types/errorRespose';
import { useMutation, UseMutationResult } from 'react-query';

export type updateUserVariables = {
  updateUserDto: UpdateUserDto,
  userId: string,
};

type UseUpdateUserPassword = (
  usersApiV2: UsersV2Api,
  options?: Omit<
    UseMutationOptions<AxiosResponse<void>, ErrorResponse, updateUserVariables>,
    'mutationFn'
    >,
) => UseMutationResult<AxiosResponse<void>, ErrorResponse, updateUserVariables>;

export const useUpdateUser: UseUpdateUserPassword = (
  usersApiV2,
  options,
) => {
  const tenantId = localStorage.getItem('tenantId') as string;
  return useMutation(
    ({ updateUserDto, userId }) =>
      usersApiV2.updateUser(tenantId, userId, updateUserDto),
    options,
  );
};
